const pageNameKey = "otaFirmwareStart";

export const otaFirmwareStartEn = {
  [pageNameKey]: {
    noFirmwareAvailableText: "No firmware available",
    uploadYourFirmwareText: "Upload your firmware",
    uploadFirmwareText: "Upload Firmware",
  },
};

export const otaFirmwareStartPtBr = {
  [pageNameKey]: {
    noFirmwareAvailableText: "Nenhum firmware disponível",
    uploadYourFirmwareText: "Envie seu firmware",
    uploadFirmwareText: "Enviar firmware",
  },
};

export const otaFirmwareStartDe = {
  [pageNameKey]: {
    noFirmwareAvailableText: "Keine Firmware verfügbar",
    uploadYourFirmwareText: "Laden Sie Ihre Firmware hoch",
    uploadFirmwareText: "Firmware hochladen",
  },
};

export const otaFirmwareStartZhHans = {
  [pageNameKey]: {
    noFirmwareAvailableText: "无可用固件",
    uploadYourFirmwareText: "上传您的固件",
    uploadFirmwareText: "上传固件",
  },
};

export const otaFirmwareStartIt = {
  [pageNameKey]: {
    noFirmwareAvailableText: "Nessun firmware disponibile",
    uploadYourFirmwareText: "Carica il firmware",
    uploadFirmwareText: "Carica Firmware",
  },
};

export const otaFirmwareStartEs = {
  [pageNameKey]: {
    noFirmwareAvailableText: "No hay firmware disponible",
    uploadYourFirmwareText: "Sube tu firmware",
    uploadFirmwareText: "Subir firmware",
  },
};

export const otaFirmwareStartNl = {
  [pageNameKey]: {
    noFirmwareAvailableText: "Geen firmware beschikbaar",
    uploadFirmwareText: "Firmware uploaded",
    uploadYourFirmwareText: "Upload uw firmware",
  },
};

export const otaFirmwareStartTr = {
  [pageNameKey]: {
    noFirmwareAvailableText: "Firmware yok",
    uploadFirmwareText: "Firmware'i Yükle",
    uploadYourFirmwareText: "Firmware'inizi yükleyin",
  },
};
